import { useEffect, useState } from 'preact/hooks';
import { services } from '../app';
import { OnNow, calendarFocus, dismissOnNow, onNow, onNowDismissed, tzOf } from '../live/skycalendar';
import { saudiStarts } from '../live/saudi';
import { eventsAroundSoon } from '../live/skyevents';
import { panel, place, previewFrom, reliving, selection, settings, skyBand, timeLive } from '../state';
import { Icon } from './icons';

/**
 * One slim line over the sky when something is on: an eclipse soon, the crescent of Ramaḍān, Shawwāl or
 * Dhū al-Ḥijjah, a shower's peak or another major sight tonight, or a major meteor shower under way.
 * Tapping it opens the sky calendar at that event; the cross hides that message for good. It is about
 * home and now, so it stays away while another place or another time is on the sky.
 */
export function OnNowChip() {
  const s = services.value;
  const [item, setItem] = useState<OnNow | null>(null);
  const pl = place.value;
  const dismissed = onNowDismissed.value;
  // Worked out again when Saudi Arabia's decision arrives, so the crescent's line goes at once.
  const decided = saudiStarts.value;
  useEffect(() => {
    if (!s) return;
    let stop = () => {};
    const run = () => {
      const home = previewFrom.peek()?.home ?? place.peek();
      const now = Date.now();
      stop();
      // Worked out in the events worker, so the sky keeps moving meanwhile.
      stop = eventsAroundSoon(home, now, s.meteors.showers, settings.peek().bortle, (list) => setItem(onNow(list, now, tzOf(home), onNowDismissed.peek())));
    };
    // After start-up has settled (and the showers have loaded), then every half hour.
    let first: ReturnType<typeof setTimeout> | undefined;
    void s.meteors.ready.then(() => (first = setTimeout(run, 2500)));
    const every = setInterval(run, 30 * 60e3);
    return () => {
      clearTimeout(first);
      clearInterval(every);
      stop();
    };
  }, [s, pl.lat, pl.lon, dismissed, decided]);
  if (!item || dismissed.has(item.key) || panel.value || selection.value || previewFrom.value || reliving.value || skyBand.value || !timeLive.value) return null;
  return (
    <div class="on-now" role="group" aria-label="On now">
      <button class="on-now-main" onClick={() => { calendarFocus.value = item.event.id; panel.value = 'calendar'; }}>
        <Icon name={item.event.icon} size={15} /> <span class="chip-text">{item.text}</span>
      </button>
      <button class="on-now-close" aria-label="Hide this notice" onClick={() => dismissOnNow(item.key)}><Icon name="close" size={14} /></button>
    </div>
  );
}
